import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Impressum (gesetzlich vorgeschrieben gemäß § 5 TMG)
 * Stand: Februar 2026 — Daten der DuTACS GmbH (Geschäftsführer-bestätigt).
 */
export default function ImprintPage() {
    return (
        <div className="min-h-screen bg-neutral-50 dark:bg-neutral-950 py-12" data-testid="imprint-page">
            <div className="max-w-3xl mx-auto px-6">
                <Link to="/login" className="inline-flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-200 mb-6" data-testid="imprint-back-link">
                    <ArrowLeft className="w-4 h-4" /> Zurück
                </Link>

                <h1 className="text-4xl font-bold tracking-tight mb-8">Impressum</h1>

                <section className="prose dark:prose-invert max-w-none space-y-6 text-sm leading-relaxed">
                    <div>
                        <h2 className="text-lg font-semibold mb-2">Angaben gemäß § 5 TMG</h2>
                        <p>
                            <strong>DuTACS GmbH</strong><br />
                            Mörfelder Straße 97<br />
                            65451 Kelsterbach<br />
                            Deutschland
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Vertreten durch</h2>
                        <p>
                            Geschäftsführer:<br />
                            Rüstü Dücan<br />
                            Veysel Pountso<br />
                            Seyfullah Pountso
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Kontakt</h2>
                        <p>
                            Telefon: <a href="tel:+4961079899963" className="underline">+49 (0)6107 9899963‑0</a><br />
                            E-Mail: <a href="mailto:info@dutacs.de" className="underline">info@dutacs.de</a>
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Registereintrag</h2>
                        <p>
                            Eintragung im Handelsregister.<br />
                            Registergericht: Amtsgericht Darmstadt<br />
                            Registernummer: <strong>HRB 104140</strong>
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Umsatzsteuer-ID</h2>
                        <p>
                            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: <strong>DE357990281</strong>
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                        <p>
                            Die Geschäftsführung der DuTACS GmbH (siehe oben).<br />
                            Mörfelder Straße 97, 65451 Kelsterbach
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">EU-Streitschlichtung</h2>
                        <p>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                            {" "}
                            <a href="https://ec.europa.eu/consumers/odr/" className="underline" target="_blank" rel="noreferrer">
                                https://ec.europa.eu/consumers/odr/
                            </a>
                            <br />
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                        <p>
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                            Verbraucherschlichtungsstelle teilzunehmen.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold mb-2">Haftungsausschluss</h2>
                        <p>
                            <strong>Haftung für Inhalte:</strong> Die Inhalte unserer Seiten wurden mit größter
                            Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                            können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
                            Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                            verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
                        </p>
                        <p className="mt-2">
                            <strong>Haftung für Links:</strong> Unser Angebot enthält ggf. Links zu externen
                            Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir
                            für diese fremden Inhalte auch keine Gewähr übernehmen.
                        </p>
                        <p className="mt-2">
                            <strong>Urheberrecht:</strong> Die durch die Seitenbetreiber erstellten Inhalte und
                            Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
                            Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
                            Urheberrechtes bedürfen der schriftlichen Zustimmung der DuTACS GmbH.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}
